import { IconType } from '@/types';

export default function SignoutIcon({ color, className, width = 19, height = 18 }: IconType) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.8333 9H8.3125M14.25 11.25L16.625 9L14.25 6.75M10.2917 5.25V4.5C10.2917 4.10218 10.1248 3.72064 9.82792 3.43934C9.53098 3.15804 9.12826 3 8.70833 3H4.75C4.33007 3 3.92734 3.15804 3.63041 3.43934C3.33348 3.72064 3.16666 4.10218 3.16666 4.5V13.5C3.16666 13.8978 3.33348 14.2794 3.63041 14.5607C3.92734 14.842 4.33007 15 4.75 15H8.70833C9.12826 15 9.53098 14.842 9.82792 14.5607C10.1248 14.2794 10.2917 13.8978 10.2917 13.5V12.75'
        strokeWidth='2'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
